import { useMutation } from '@tanstack/react-query';
import { QUERY_KEYS } from '../base-api';
import type { ViewCountRequestParams } from '../types/view.type';
import { postViewCount } from '../view.service';

/**
 * 페이지 접근 누계 등록 (POST /v1/view-count)
 *
 * @example
 * ```tsx
 * const { mutate: viewCount } = useViewCount();
 * viewCount({ type: '메인' });
 * viewCount({ type: '학원상세', academyId: 123, location: '...', hash: '...' });
 * ```
 */
export const useViewCount = () => {
  return useMutation({
    mutationKey: [QUERY_KEYS.VIEW_COUNT],
    mutationFn: (body: ViewCountRequestParams) => postViewCount(body),
  });
};
